module.exports = require("@mui/material/DialogActions");